import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';

export const groupFromBE = (group: any) =>
	group
		? {
				...group,
				service: group.service_id,
				service_template: group.service_template_id,
			}
		: group;

const BASE = '/cgParents';

export const getCgParents = async (query: ITableDataQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createCgParents = async (data: any) => backend.post(`${BASE}`, data);

export const getCgParent = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeCgParent = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveCgParent = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data);

export const getParentsReport = async (data: { from: string; to: string }) =>
	backend.post(`${BASE}/report`, data);
